import { render, staticRenderFns } from "./CreditCardPreview.vue?vue&type=template&id=52d896ac&"
import script from "./CreditCardPreview.vue?vue&type=script&lang=js&"
export * from "./CreditCardPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports